import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "julia",
  extensions: [".jl"],
  aliases: ["julia", "Julia"],
  loader: () => import('./julia.js')
});
